const caseStatusList = [
    'Draft',
    'Waiting on Support',
    'Awaiting your reply',
    'Resolved',
];

export { caseStatusList };
